
import { SET_DEVICE_NAME } from '../actions';

const initialState = { deviceName: '' };

const acquisitionsMetricsPage = (state = initialState, action ) => {
  if (action.type === SET_DEVICE_NAME) {
    return {
      ...state,
      deviceName: action.deviceName
    };
  }
  return state;
};

export default acquisitionsMetricsPage;

const getAcquisitionsMetricsPage = state => state.acquisitionsMetricsPage;
export const getDeviceName = state => getAcquisitionsMetricsPage(state).deviceName;


// WEBPACK FOOTER //
// src/reducers/acquisitionsMetricsPage.js